<mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
  <mat-label>Search projects, phases & tasks</mat-label>
  <mat-icon matPrefix>search</mat-icon>
  <input matInput [formControl]="searchControl" placeholder="Search by number or name...">
  @if (searchControl.value) {
    <button matSuffix mat-icon-button (click)="resetSearch()">
      <mat-icon>close</mat-icon>
    </button>
  }
</mat-form-field>
